import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { UserContextProvider } from "./context/dashboard-context";
import { ImageUploadProvider } from "./context/ImageUploadContext"; // ImageUploadProvider ni import qo'shing

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <UserContextProvider>
        <ImageUploadProvider> {/* ImageUploadProvider ni qo'shing */}
          <App />
        </ImageUploadProvider> {/* ImageUploadProvider ni qo'shing */}
      </UserContextProvider>
    </BrowserRouter>
  </React.StrictMode>
);
